module.exports = __webpack_public_path__ + "static/img/tt-er.bba6cd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tt-er.jpg
// module id = AQsu
// module chunks = 114